export const TERMS_CONTENT = `
1. Introduction
Welcome to Susegado Strike.
These Terms & Conditions ("Terms") govern your access to and use of the Susegado Strike website, ticketing platform, mobile applications (if applicable), social media promotions, merchandise store, and all events organised, promoted or operated by Susegado Strike ("Susegado Strike", "we", "our", or "us").
By accessing our website, purchasing tickets, attending an event, registering for an account, or using any of our services, you acknowledge that you have read, understood and agree to be legally bound by these Terms.
If you do not agree with these Terms, you should immediately discontinue use of our website and services.

2. About Susegado Strike
Susegado Strike is a professional boxing promotion based in Goa, India.
Our services may include:
• Professional boxing events
• Ticket sales
• Event registrations
• Livestream access
• VIP hospitality
• Merchandise sales
• Promotional campaigns
• Membership programmes
• Community initiatives
• Digital media and content
• Sponsorship opportunities
Additional services may be introduced from time to time.

3. Definitions
For the purpose of these Terms:
"Event" means any boxing event, fight night, weigh-in, press conference, fan event, livestream or other activity organised or promoted by Susegado Strike.
"Ticket" means any digital, printed, electronic, QR code or other authorised form of admission issued by Susegado Strike or its authorised ticketing partners.
"Venue" means the location where an Event is conducted.
"Website" means www.susegadostrike.com and any associated sub-domains.
"Customer", "You", and "Your" refer to any person accessing our services.
"Services" means all products, digital services and experiences provided by Susegado Strike.

4. Eligibility
By using our Services, you confirm that:
• You are at least 18 years of age; or
• You are using the Services under the supervision of a parent or legal guardian.
You further represent that:
• the information you provide is accurate;
• you have legal capacity to enter into binding agreements;
• you will comply with applicable Indian laws.
We reserve the right to refuse access to anyone who violates these Terms.

5. User Accounts
Certain Services may require you to create an account.
You agree to:
• provide accurate information;
• keep your password secure;
• maintain current contact details;
• immediately notify us of any unauthorised use.
You remain responsible for all activities carried out using your account.
We reserve the right to suspend or terminate accounts that contain inaccurate information or are used fraudulently.

6. Ticket Purchases
Tickets purchased through Susegado Strike or authorised ticketing partners grant admission only to the Event specified on the Ticket.
Availability is subject to capacity.
Purchase of a Ticket does not guarantee:
• a particular seat unless specifically allocated;
• proximity to the ring;
• uninterrupted viewing;
• access to restricted areas.
VIP packages may include additional benefits as described at the time of purchase.

7. Pricing
Ticket prices are determined by Susegado Strike.
Prices may vary based on:
• seating category;
• purchase date;
• promotional campaigns;
• availability;
• hospitality packages.
All applicable taxes and convenience fees will be displayed prior to checkout.
Prices may change without notice until payment has been successfully completed.

8. Payment
Payments may be accepted using approved payment methods including:
• Credit Cards
• Debit Cards
• UPI
• Net Banking
• Digital Wallets
• Other authorised payment providers
Payments are processed through secure third-party payment gateways.
Susegado Strike does not store complete payment card details.
Orders are confirmed only after successful payment authorisation.

9. Ticket Delivery
Tickets may be delivered through:
• Email
• SMS
• WhatsApp
• Mobile Wallet
• QR Code
• Digital Pass
• Physical Ticket (where applicable)
Customers are responsible for ensuring that their contact information is accurate.
Failure to receive a confirmation due to an incorrect email address, spam filters, network issues or customer error does not invalidate the purchase.

10. Entry Requirements
Entry to an Event is subject to:
• possession of a valid Ticket;
• successful ticket verification;
• compliance with venue rules;
• successful completion of security screening;
• production of government-issued identification if requested.
Susegado Strike reserves the right to deny admission where:
• Tickets are suspected to be counterfeit;
• Tickets have been tampered with;
• Tickets have already been scanned;
• Entry conditions are not met.

11. Ticket Transfers
Unless expressly permitted by Susegado Strike, Tickets are intended solely for personal use.
Tickets may not be:
• resold for commercial gain;
• auctioned;
• transferred in bulk;
• offered through unauthorised resale platforms.
Any Ticket obtained through unauthorised channels may be cancelled without refund.
Susegado Strike reserves the right to pursue legal action against individuals involved in ticket fraud, scalping or unauthorised resale.

12. Fight Card Changes
Professional boxing is a live sporting event.
Fight cards remain subject to change due to circumstances including:
• injury;
• illness;
• medical suspension;
• visa issues;
• licensing requirements;
• travel disruptions;
• regulatory decisions;
• force majeure;
• promoter discretion.
Accordingly:
• Individual bouts are not guaranteed.
• Fighters may be replaced.
• Bout order may change.
• Championship bouts may become non-title bouts.
• Supporting fights may be added or removed.
Such changes shall not automatically entitle ticket holders to refunds unless expressly determined by Susegado Strike.

13. Event Schedule Changes
Susegado Strike reserves the right to:
• postpone an Event;
• reschedule an Event;
• relocate an Event;
• modify event timings;
• change doors-open times;
• alter programme schedules.
Customers should regularly monitor official communication channels for updates.
In the event of rescheduling, previously issued Tickets may remain valid unless otherwise communicated.

14. Refund & Cancellation Policy
All ticket sales are final unless otherwise stated in writing by Susegado Strike.
Tickets are generally non-refundable, non-exchangeable and non-transferable.
Refunds shall only be considered under the following circumstances:
• The Event is cancelled and not rescheduled.
• The Event is cancelled by Susegado Strike.
• A refund is expressly announced by Susegado Strike.
Refunds will not be issued for:
• Change of personal plans.
• Weather conditions where the Event proceeds.
• Traffic delays.
• Late arrival.
• Missed entry.
• Partial attendance.
• Change of venue within the same city.
• Change in fight card.
• Replacement of fighters.
• Seating preference disputes.
• Loss or theft of tickets.
• Failure to comply with venue rules.
Where refunds are approved, only the face value of the ticket shall be refunded unless otherwise stated.
Convenience fees, processing charges, delivery charges and payment gateway charges are non-refundable unless required under applicable law.
Refunds, where applicable, shall be processed to the original mode of payment within a reasonable period after confirmation.

15. Event Cancellation & Postponement
Susegado Strike reserves the right to postpone, reschedule or cancel any Event due to circumstances including but not limited to:
• Government orders
• Natural disasters
• Force majeure events
• Venue unavailability
• Public safety concerns
• Medical emergencies
• Regulatory decisions
• Promoter discretion
Where an Event is postponed, previously purchased Tickets may remain valid for the revised date unless otherwise communicated.
Should ticket holders be unable to attend the rescheduled Event, refund eligibility shall be determined solely in accordance with the announced Event policy.

16. Admission to the Venue
Entry to any Susegado Strike Event is conditional upon compliance with all venue rules.
The Promoter reserves the right to refuse admission to any individual who:
• Is unable to produce a valid ticket.
• Appears intoxicated.
• Is under the influence of illegal substances.
• Behaves aggressively or abusively.
• Refuses security screening.
• Attempts to gain unauthorised access.
• Carries prohibited items.
• Presents forged or duplicated tickets.
• Violates applicable laws.
No compensation shall be payable for refusal of admission arising from the above circumstances.

17. Security Screening
All attendees agree that they and their belongings may be searched before entering the Venue.
Security personnel may inspect:
• Bags
• Clothing
• Jackets
• Backpacks
• Electronic devices where reasonably necessary
Failure to cooperate with security procedures may result in refusal of entry or removal from the Venue without refund.

18. Prohibited Items
The following items are prohibited unless specifically authorised:
• Firearms
• Knives
• Weapons of any kind
• Explosives
• Fireworks
• Laser pointers
• Illegal drugs
• Alcohol purchased outside the Venue
• Glass bottles
• Large bags
• Drones
• Professional recording equipment
• Selfie sticks
• Flags or banners deemed offensive
• Smoke bombs
• Flares
• Hazardous materials
Susegado Strike reserves the right to update the prohibited items list at any time.
Confiscated items may not be returned.

19. Alcohol & Intoxication
Alcohol may only be consumed where permitted by law and by the Venue.
Attendees acknowledge that:
• Excessive intoxication may result in refusal of entry.
• Service of alcohol remains at the discretion of the Venue.
• Illegal substances are strictly prohibited.
Any person creating a disturbance due to intoxication may be removed from the Venue without refund.

20. Code of Conduct
All attendees are expected to behave respectfully toward:
• Fighters
• Officials
• Staff
• Sponsors
• Media
• Other spectators
The following behaviour is prohibited:
• Violence
• Fighting
• Harassment
• Racism
• Sexism
• Hate speech
• Threatening behaviour
• Throwing objects
• Damaging Venue property
• Entering restricted areas
• Entering the competition area or ring
• Disrupting the Event
Susegado Strike may remove any attendee whose behaviour compromises the safety or enjoyment of others.
Serious incidents may be reported to law enforcement authorities.

21. Removal from the Venue
Susegado Strike, Venue management and authorised security personnel reserve the right to remove any attendee without refund where they:
• Breach these Terms.
• Ignore staff instructions.
• Engage in criminal conduct.
• Endanger public safety.
• Damage property.
• Disrupt the Event.
• Interfere with officials or athletes.
Removal from the Venue shall not entitle the attendee to any refund or compensation.

22. Photography, Recording & Broadcasting
Susegado Strike Events are professionally photographed, livestreamed and recorded.
By entering the Venue, you acknowledge and agree that your:
• Image
• Voice
• Likeness
• Name (where applicable)
may appear in:
• Live broadcasts
• Television coverage
• Streaming platforms
• Promotional videos
• Documentary productions
• Social media
• Marketing campaigns
• Future Event promotions
You irrevocably grant Susegado Strike the right to use such recordings without additional notice or compensation.

23. Personal Photography
Guests may capture photographs and short videos for personal, non-commercial use unless otherwise instructed.
The following are prohibited without prior written permission:
• Commercial filming
• Live broadcasting
• Professional photography
• Recording for resale
• Use of drones
• Use of large camera rigs or tripods
Susegado Strike reserves the right to request deletion of unauthorised commercial recordings.

24. Medical Emergencies
Attendees are responsible for informing Venue staff immediately in the event of a medical emergency.
Qualified medical personnel may provide emergency assistance where available.
Susegado Strike does not guarantee uninterrupted medical services and shall not be liable for delays arising from circumstances beyond its reasonable control.

25. Assumption of Risk
Professional boxing is a contact sport.
By attending an Event, you acknowledge that attendance carries inherent risks including, but not limited to:
• Loud noise
• Bright lighting
• Pyrotechnics (where applicable)
• Flying debris
• Crowd movement
• Accidental contact with participants or equipment
• Emergency evacuations
You voluntarily assume all ordinary risks associated with attending a live sporting event.
To the fullest extent permitted by law, Susegado Strike shall not be liable for injury, loss or damage arising from such inherent risks except where caused by its gross negligence or wilful misconduct.

26. Lost Property
Susegado Strike is not responsible for lost, stolen or damaged personal belongings.
Any property recovered during the Event may be handed to Venue management.
Unclaimed items may be disposed of in accordance with Venue policy.
Attendees are solely responsible for safeguarding their personal belongings throughout the Event.
`;

export const PRIVACY_CONTENT = `
1. Introduction
Susegado Strike ("Susegado Strike", "we", "us", or "our") respects your privacy and is committed to protecting the personal information you share with us.
This Privacy Policy explains how we collect, use, store, disclose, and protect your personal information when you visit our website, purchase tickets, attend our events, interact with us through social media, subscribe to our communications, or otherwise engage with our services.
By accessing or using our website or services, you acknowledge that you have read and understood this Privacy Policy and consent to the collection and use of your information as described herein.

2. Scope
This Privacy Policy applies to:
• Visitors to susegadostrike.com
• Ticket purchasers
• Event attendees
• Newsletter subscribers
• Sponsors and partners
• Vendors and service providers
• Individuals contacting us through our website, email or social media
• Users interacting with our digital platforms
This Policy does not apply to third-party websites or services that may be linked from our website.

3. Information We Collect
We may collect the following categories of information.
Personal Information
• Name
• Email address
• Mobile number
• Postal address
• Billing address
• Date of birth (where applicable)
• Government identification where required by law
• Emergency contact details for specific events
Ticketing Information
When purchasing tickets, we may collect:
• Ticket type
• Order history
• Transaction ID
• Seating information
• Attendance details
• Event preferences
Payment information is processed securely by our payment gateway partners. We do not store your complete debit or credit card information.
Communications
Information provided when you:
• Contact customer support
• Submit enquiries
• Complete forms
• Participate in promotions
• Enter competitions
• Subscribe to newsletters
• Respond to surveys
Event Information
Where applicable we may collect:
• Accessibility requirements
• Seating requests
• Dietary information for hospitality areas
• VIP guest information
• Accreditation details
• Media registration information
Images and Video
Susegado Strike events may be photographed or filmed.
By attending an event you acknowledge that your image, likeness or voice may appear in:
• Event photography
• Promotional videos
• Broadcasts
• Livestreams
• Social media content
• Marketing materials
• Future promotional campaigns
These materials may be used without additional notice or compensation.
Website Usage Information
We automatically collect certain technical information including:
• IP address
• Browser type
• Device type
• Operating system
• Language preferences
• Pages visited
• Time spent on pages
• Referral URLs
• Clickstream information
Cookies
Our website uses cookies and similar technologies to:
• Improve website functionality
• Remember preferences
• Analyse traffic
• Measure marketing effectiveness
• Enhance user experience
You may disable cookies through your browser settings, although certain website features may not function correctly.

4. How We Collect Information
Information may be collected:
• Directly from you
• During ticket purchases
• Through website forms
• Through newsletter sign-ups
• During sponsorship enquiries
• Via social media interactions
• Automatically through cookies
• Through trusted payment providers
• Through analytics providers

5. How We Use Your Information
We use your information to:
• Process ticket purchases
• Deliver event services
• Confirm bookings
• Provide customer support
• Respond to enquiries
• Improve our website
• Personalise user experiences
• Communicate event updates
• Send newsletters (where consent has been provided)
• Prevent fraud
• Maintain security
• Comply with legal obligations
• Conduct internal reporting and analytics

6. Marketing Communications
With your consent, we may send:
• Event announcements
• Ticket launches
• Presale access
• Promotional offers
• Merchandise releases
• Sponsor activations
• Newsletters
• Future Fight Night updates
You may unsubscribe at any time by clicking the unsubscribe link in our emails or contacting us directly.

7. Event Photography and Media
Susegado Strike events are public sporting events.
Photographers, videographers, broadcasters and media partners may capture images and recordings throughout the venue.
These recordings may be used for:
• Live broadcasts
• Highlights
• Marketing
• Documentary content
• Social media
• Historical archives
• Promotional campaigns
If you do not wish to appear in photographs, please contact venue staff prior to the commencement of the event. While we will make reasonable efforts, we cannot guarantee exclusion from crowd footage.

8. Sharing Your Information
We may share your information with trusted third parties including:
• Payment processors
• Ticketing providers
• Event management platforms
• Venue operators
• Security providers
• Marketing agencies
• Email communication providers
• Technology providers
• Professional advisers
• Government authorities where legally required
We do not sell your personal information.

9. Third-Party Services
Our website may contain links to external websites including:
• Payment gateways
• Sponsors
• Social media platforms
• Streaming platforms
• Merchandise partners
We are not responsible for the privacy practices of those third parties.

10. Data Security
We implement appropriate technical and organisational safeguards designed to protect your personal information against:
• Unauthorised access
• Loss
• Misuse
• Alteration
• Disclosure
• Destruction
Despite these safeguards, no internet transmission or electronic storage system can be guaranteed to be completely secure.

11. Data Retention
We retain your information only for as long as necessary to:
• Provide our services
• Maintain business records
• Resolve disputes
• Enforce agreements
• Comply with legal obligations
• Meet accounting and tax requirements
Once information is no longer required, it will be securely deleted or anonymised.

12. Children's Privacy
Our services are intended for individuals aged 18 years or older.
Where minors attend our events under the supervision of a parent or legal guardian, any personal information provided must be submitted by the accompanying adult.

13. Your Rights
Subject to applicable law, you may have the right to:
• Access your personal information
• Correct inaccurate information
• Request deletion of your information
• Withdraw marketing consent
• Restrict certain processing
• Request a copy of your information
• Object to specific processing activities
Requests may be submitted using the contact details below.

14. International Data Transfers
Where necessary, your information may be processed by trusted service providers located outside your country of residence.
Appropriate safeguards will be implemented where required by applicable law.

15. Changes to this Privacy Policy
We may update this Privacy Policy periodically.
The revised version will be published on our website together with the updated "Last Updated" date.
Continued use of our website or services after changes become effective constitutes acceptance of the revised Privacy Policy.

16. Contact Us
If you have any questions regarding this Privacy Policy or the way your personal information is handled, please contact us.
Susegado Strike
Email: info@susegadostrike.com
Website: www.susegadostrike.com
Goa, India

17. Consent
By accessing our website, purchasing tickets, attending our events or otherwise using our services, you acknowledge that you have read and understood this Privacy Policy and consent to the collection, use and disclosure of your personal information as described herein.
`;
